import { createAsyncThunk } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

export const setYearUseCase = createAsyncThunk(
  'setYearUseCase',
  async (
    data: { year: number },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    let { month } = getState().archives.suiviInstruction;

    if (!month) {
      const today = DateTime.local();
      month = today.month;
    }

    return {
      year: data.year,
      month: month,
    };
  }
);

export default setYearUseCase;
